import { REGEX_PATTERNS } from '@constants';
import * as yup from 'yup';

const activeDriver = (value) => {
  return value;
};

const validationSchema = yup.object({
  firstName: yup
    .string()
    .required('Required')
    .matches(/^[^\d]*$/, 'First name cannot contain digits'),
  lastName: yup
    .string()
    .required('Required')
    .matches(/^[^\d]*$/, 'First name cannot contain digits'),
  email: yup.string().email().required('Required'),
  phoneNumber: yup
    .string()
    .required('Required')
    .matches(
      REGEX_PATTERNS.Phone,
      'Phone Number should follow the E.164 format, e.g. +30xxxxxxxxxx'
    ),
  role: yup.string().required('Required'),
  lang: yup.string().required('Required'),
  dateOfBirth: yup.string().when(['activeDriver'], {
    is: activeDriver,
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired(),
  }),
  driversLicenseIssueDate: yup.string().when(['activeDriver'], {
    is: activeDriver,
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired(),
  }),
  driversLicenseNumber: yup.string().when(['activeDriver'], {
    is: activeDriver,
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired(),
  }),
});

export default validationSchema;
